import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger, viewport } from "@/lib/motion";
import { OUTCOMES } from "@/data/smartContainer";
import SectionHeader from "./SectionHeader";

export default function OutcomesSection() {
  return (
    <section className="py-24 sm:py-32" data-testid="outcomes-section">
      <div className="dm-container">
        <SectionHeader
          eyebrow="Business Outcomes"
          title="Less to manage. More control. One shipment."
          description="SmartContainer™ turns fragmented, high-effort sourcing into a lean, factory-direct procurement operation."
        />
        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewport}
          className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {OUTCOMES.map((o) => (
            <motion.div key={o.title} variants={fadeUp} className="dm-card dm-card-hover p-7 flex items-start gap-4"
              data-testid={`outcome-card-${o.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className="grid place-items-center h-11 w-11 rounded-xl bg-slate-50 border border-slate-200 shrink-0">
                <o.icon className="h-5 w-5 text-blue-600" strokeWidth={1.75} />
              </span>
              <div>
                <h3 className="text-base font-bold text-slate-900">{o.title}</h3>
                <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{o.text}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
